import api from "@/requests";

export const getLimitsInsteadClosing = () =>
  api
    .get("api/v1/Myred/GetLimitsInsteadClosing")

export const setLimitInsteadClosing = (limit) =>
  api.post("api/v1/Myred/SetLimitInsteadClosing", limit);

export const getCloseReasons = () =>
  api.get("api/v1/Myred/GetCloseReasons");

export const closeRed = () => api.post("api/v1/Myred/CloseRed");

export const getDetailsOnClose = () =>
  api.get("api/v1/Myred/GetDetailsOnClose");

export function transferAndCloseRed(simpleId) {
  return api.get(`api/v1/Myred/TransferAndCloseRed/${simpleId}`);
}
